import { render, staticRenderFns } from "./SpotsCarousel.vue?vue&type=template&id=3ff366b3"
import script from "./SpotsCarousel.vue?vue&type=script&lang=js"
export * from "./SpotsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports